import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function numbersOnly(nameRe: RegExp): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const passwordValid = nameRe.test(control.value);
        return !passwordValid ? { passwordStrength: true } : null;
    };
}
